// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"207":"history-page","258":"pay-page","733":"payable-page","902":"virtual-account-page"}[chunkId] + "-" + {"207":"bbdcb42c471cbb288d95","258":"cf8363daf87455c71950","733":"bbdcb42c471cbb288d95","902":"6fd9e42414230b18b932"}[chunkId] + ".css";
};